
import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from "react-router-dom";
import { capitalize } from 'lodash';

import Modal, { ModalHeader, ModalContent, ModalActions } from '@vromo/ui/components/Modal';
import OverlayablePanel from '@vromo/ui/components/Overlay';
import Title from '@vromo/ui/components/Title';
import Button from '@vromo/ui/components/Button';
import { IntegrationProfile, IntegrationsConfig, Platform } from '@vromo/models/integrations';
import { useIntegrationLocations, useIntegrationsActions, useIntegrationsNav, useIntegrationsPage } from '../../hooks';
import { useToasts } from '@vromo/ui';
import { useModals } from '@vromo/ui/components/Modals';
import { IntegrationLocations } from "../../components"
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { dataTestId } from '@vromo/models';
import { EditButton } from '.';

/* type IntegrationDetailsProps = {
    action: "add" | "edit" | "view"
} */

export const IntegrationDetails = observer(() => {

    const { platform } = useParams<{ platform: Platform }>()
    const showToast = useToasts();
    const modals = useModals();
    const {
        goToWindow,
        modalOpen, closeModal,
    } = useIntegrationsNav({ modalOpened: true })
    const { deleteIntegration } = useIntegrationsActions()
    const { queryLocations } = useIntegrationLocations()
    const { isLoading, fetched, fetchedIntegrations, allPosibleIntegrations } = useIntegrationsPage()


    const instance = fetchedIntegrations.get(platform)
    const { features: { locations = false } = {} } = IntegrationsConfig[platform] ?? {}




    // return to integrations home if integration doesnt exist
    useEffect(() => {
        if (!allPosibleIntegrations.includes(platform) ||
            (
                fetched &&
                !fetchedIntegrations.has(platform)
            )
        ) {
            showToast(`integration '${capitalize(platform)}'  is not available`, 'warning')
            goToWindow("list")
        }
    }, [fetchedIntegrations, fetched])



    return (
        <Modal isOpen={modalOpen} onRequestClose={() => !isLoading && closeModal()} showCloseButton={!isLoading}>
            <OverlayablePanel active={isLoading} loadingText='Loading'>
                <ModalHeader>
                    <Title style={{ textTransform: 'capitalize' }}>{platform} integration</Title>
                </ModalHeader>
                {
                    fetched &&
                    <ModalContent>
                        <IntegrationSettings instance={instance} />
                        <IntegrationLocations required={locations} />
                    </ModalContent>
                }
                <ModalActions>
                    <Button onClick={closeModal}>
                        close
                    </Button>
                    {
                        // locations && instance?.completed &&
                        locations &&
                        instance?.completed &&
                        instance.features?.locations &&
                        <Button
                            primary
                            onClick={() => queryLocations(instance!.platform, "fetch")}
                            data-testid={dataTestId.integration.locations.refresh}
                        >
                            refresh locations
                        </Button>
                    }
                    {
                        fetched &&
                        <>
                            <Button
                                primary
                                onClick={async () => {
                                    if (
                                        await modals.confirm(
                                            `Delete ${instance!.platform} integration`,
                                            `Are you sure you want to delete this integration?`
                                        )
                                    ) {
                                        deleteIntegration(instance!.platform)
                                        closeModal()
                                    }
                                }}
                            >
                                delete
                            </Button>
                            <EditButton
                                instance={instance}
                                action={() => goToWindow("config", instance!.platform)}
                            />
                        </>
                    }

                </ModalActions>
            </OverlayablePanel>
        </Modal >
    );
});



const IntegrationSettings: FC<{ instance?: IntegrationProfile }> = ({ instance }) => {
    if (!instance)
        return null
    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <FontAwesome icon="cog" style={{ marginRight: 10 }} />
                <h3>Details</h3>
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                    flex: 1,
                    width: '100%',
                    paddingLeft: '10px',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word'
                }}>
                    <dl>
                        <dt>External reference</dt>
                        <dd>{
                            [Platform.square, Platform.square_sandbox].includes(instance.platform) ?
                                instance.ext_title!.replace(instance.platform + "_", "") :
                                instance.ext_ref
                        }</dd>
                    </dl>
                </div>
            </div>
        </>
    )
}